"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
const useSASQQueryMeta = id => {
  const {
    0: namespace
  } = (0, _core.useNamespace)();
  const queryClient = (0, _reactQuery.useQueryClient)();
  const queryNSBase = [namespace, 'SASQ'];
  if (id) {
    queryNSBase.push(id);
  }
  const lookupQueryNS = [...queryNSBase, 'viewAll'];
  const viewQueryNS = [...queryNSBase, 'view'];
  return {
    lookupQueryNS,
    viewQueryNS,
    invalidateLookupQuery: () => queryClient.invalidateQueries(lookupQueryNS),
    invalidateViewQuery: viewId => {
      const invalidateNS = [...viewQueryNS];
      if (viewId) {
        invalidateNS.push(viewId);
      }
      queryClient.invalidateQueries(invalidateNS);
    }
  };
};
var _default = exports.default = useSASQQueryMeta;